// extracted by mini-css-extract-plugin
module.exports = {"phoneUSGif":"AnimatedPhone-module__phoneUSGif___2OI-D","phoneGifComp":"AnimatedPhone-module__phoneGifComp___5ZRzX","gif":"AnimatedPhone-module__gif___3DpbT"};